import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DialContact, DialRiskLevelDto } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-dial-risk-case',
  templateUrl: './check-dial-risk-case.component.html',
  styleUrls: ['./check-dial-risk-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckDialRiskCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: DialRiskLevelDto;

  removeContact(index: number): void {
    this.inspection.contacts.splice(index, 1);
    this.inspection.contacts = [...this.inspection.contacts];
    this.onChange();
  }

  addContact(): void {
    this.inspection.contacts = [...this.inspection.contacts, new DialContact()];
    this.onChange();
  }
}
